/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-04-30",
    versionChannel: "nightly",
    buildDate: "2023-04-30T00:18:39.359Z",
    commitHash: "69134d7d8d4a4c29a71e4f15f99c40fb7c6e6967",
};
